import React, { useState } from "react";
import { Breadcrumb as BreadcrumbDefault, Button, Icon } from "@sicredi/react";
import { Link } from "#/components/Link";
import { BreadcrumbPropsBase, PreviousPage } from "./config";
import { useHistory } from "react-router-dom";
import ConfirmModal from "#/components/ConfirmModal";

export const Breadcrumb: React.FC<BreadcrumbPropsBase> = (config) => {
  const [urlConfirmModal, setUrlConfirmModal] = useState<string | undefined>(
    undefined
  );
  const lastPage = config.previousPages.slice(-1)[0] as PreviousPage;
  const history = useHistory();

  function quitConfirmation() {
    if (!!config.confirmationToQuit?.actionConfirm)
      config.confirmationToQuit?.actionConfirm();
    history.push(urlConfirmModal as string);
    setUrlConfirmModal(undefined);
  }

  const printBreadcrumpItem = (previousPage: PreviousPage, index: number) => {
    if (config.confirmationToQuit) {
      return (
        <BreadcrumbDefault.Item
          as={Button}
          appearance="link"
          key={index}
          onClick={() => setUrlConfirmModal(previousPage.to)}
        >
          {previousPage.name}
        </BreadcrumbDefault.Item>
      );
    }
    return (
      <BreadcrumbDefault.Item as={Link} key={index} to={previousPage.to}>
        {previousPage.name}
      </BreadcrumbDefault.Item>
    );
  };

  return (
    <>
      {config.confirmationToQuit ? (
        <ConfirmModal
          onClose={() => setUrlConfirmModal(undefined)}
          onCancel={() => setUrlConfirmModal(undefined)}
          onConfirm={quitConfirmation}
          show={!!urlConfirmModal}
          {...config.confirmationToQuit}
        />
      ) : undefined}
      <BreadcrumbDefault className="hide-mobile">
        {config.previousPages.map((previousPage, index) =>
          printBreadcrumpItem(previousPage, index)
        )}
        <BreadcrumbDefault.Item>{config.pageName}</BreadcrumbDefault.Item>
      </BreadcrumbDefault>
      <Link className="show-mobile" to={lastPage.to}>
        <Icon name="arrow-left" appearance="primary" />
      </Link>
    </>
  );
};
